var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1400 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    fill: "#060",
    height: 700
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    fill: "#fff",
    height: 500
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    fill: "#c00",
    height: 200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f8c300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 672.0,340.7 a 12.5,12.5 0,0,1 23.3,5.9 v 50 h 9.4 v -50 a 12.5,12.5 0,0,1 23.3,-5.9 a 29.5,29.5 0,1,0 -56,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 678.7,327.65 a 20,20 0,0,1 21.3,9.55 a 20,20 0,0,1 21.3,-9.55 a 21.5,21.5 0,0,0 -42.6,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M 695.3,376.627 a 38,38 0 0 1 -63.845,24.316 a 39.5,39.5 0 0 1 -59.734,17.467 c 3.6496,36.426 58.252,28.989 62.32,-6.4288 17.154,30.115 54.873,21.49 65.91,-15.4 z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    transform: "translate(700,0) scale(-1,1) translate(-700,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M 658.84,441.31 c -7.6181,16.446 -22.845,19.271 -36.164,5.9953 0,0 5.3539,-3.7831 11.086,-4.826 -1.0748,-4.5744 1.1291,-10.902 4.2354,-14.324 3.2575,2.2264 7.8036,6.6886 8.9598,11.874 8.0291,-1.0394 11.883,1.2815 11.883,1.2815 z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    transform: "rotate(9.37, 700,804)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    transform: "rotate(18.74, 700,804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 603,478 a 340,340 0 0 1 194,0",
    fill: "none",
    strokeWidth: 16,
    stroke: "#f8c300"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,380)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-140)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "s",
    points: "0,-513674 301930,415571 -488533,-158734 488533,-158734 -301930,415571",
    transform: "scale(0.000048669)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(-30) translate(0,-140) rotate(30)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(-60) translate(0,-140) rotate(60)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(-90) translate(0,-140) rotate(90)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "scale(-1,1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/tj.03bccf7e7490b7b62920e7ed9c87a1c6.svg";
export { ForwardRef as ReactComponent };